import Link from '@Components/common/Link';
import styled, { css } from 'styled-components';
import { mq } from 'stylesheets/utils';

export const Card = styled.div<{ readonly isLoading?: boolean }>`
  display: flex;
  border-bottom: 1px solid ${({ theme }) => theme.colors.auth.lightPurple};
  background-color: ${({ theme }) => theme.colors.white};
  padding: 10px 30px 20px;
  &:last-of-type {
    border-bottom: none;
  }
  ${mq(576)} {
    flex-direction: column;
    padding: 10px;
  }
  ${({ isLoading }) =>
    isLoading &&
    css`
      opacity: 0.7;
      pointer-events: none;
      cursor: not-allowed;
    `}
`;

export const PartImage = styled(Link)`
  max-width: 143px;
  min-width: 143px;
  max-height: 143px;
  min-height: 143px;
  margin-right: 16px;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  background-color: ${({ theme }) => theme.colors.lightPurple};
  ${mq(576)} {
    max-width: unset;
    width: 100%;
    margin-bottom: 8px;
  }
`;

export const Header = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 10px;
`;

export const Div = styled(Link)`
  width: 100%;
`;

export const Title = styled.p`
  font-size: ${({ theme }) => theme.fontsizes.body16};
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.black2};
  text-transform: uppercase;
`;

export const Info = styled.p`
  font-size: ${({ theme }) => theme.fontsizes.body12};
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.auth.blue};
`;

export const PriceWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const Discount = styled.p`
  width: 26px;
  height: 20px;
  line-height: 20px;
  font-size: ${({ theme }) => theme.fontsizes.body12};
  font-weight: ${({ theme }) => theme.fontWeight.font500};
  color: ${({ theme }) => theme.colors.black2};
  background-color: ${({ theme }) => theme.colors.yellow};
  margin-right: 6px;
  text-align: center;
`;

export const Price = styled.p`
  font-size: 1rem;
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.lightPurple};
  position: relative;
  line-height: 0.9;
  &::after {
    position: absolute;
    content: '';
    width: 100%;
    height: 1px;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    background-color: ${({ theme }) => theme.colors.lightPurple};
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const FlexCenter = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 6px;
`;

export const Button = styled.button<{
  readonly plus?: boolean;
}>`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  position: relative;
  background-color: ${({ theme }) => theme.colors.brandColor};
  &::before,
  &::after {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    content: '';
    min-width: 8px;
    max-width: 8px;
    min-height: 2px;
    max-height: 2px;
    border-radius: 2px;
    background-color: ${({ theme }) => theme.colors.white};
  }
  &::after {
    min-width: 2px;
    max-width: 2px;
    min-height: 8px;
    max-height: 8px;
    opacity: 0;
  }
  ${({ plus }) =>
    plus
      ? css`
          &::after {
            opacity: 1;
          }
        `
      : css``}
`;

export const Count = styled.p`
  line-height: 20px;
  width: 28px;
  text-align: center;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.counter};
  margin: 0 5px;
  font-size: ${({ theme }) => theme.fontsizes.body14};
  color: ${({ theme }) => theme.colors.black2};
  font-weight: ${({ theme }) => theme.fontWeight.font700};
`;

export const DeleteIcon = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.lightPurple};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const Total = styled.p`
  font-size: ${({ theme }) => theme.fontsizes.body12};
  font-weight: ${({ theme }) => theme.fontWeight.font600};
  color: ${({ theme }) => theme.colors.black2};
`;
export const CheckBoxesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;
